var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35254 2.21924C4.59987 1.9719 5.00072 1.9719 5.24805 2.21924C5.49529 2.46658 5.49536 2.86745 5.24805 3.11475L4.19629 4.1665H9.60059C12.3067 4.16657 14.5 6.36074 14.5 9.06689C14.4999 11.7729 12.3067 13.9662 9.60059 13.9663H5.33398C4.98427 13.9663 4.7003 13.6831 4.7002 13.3335C4.7002 12.9838 4.9842 12.6997 5.33398 12.6997H9.60059C11.6071 12.6996 13.2333 11.0734 13.2334 9.06689C13.2334 7.0603 11.6072 5.43317 9.60059 5.43311H4.19629L5.24805 6.48584C5.49533 6.73318 5.49537 7.13404 5.24805 7.38135C5.00072 7.62844 4.5998 7.62855 4.35254 7.38135L2.21973 5.24756C1.97238 5.00023 1.97238 4.59938 2.21973 4.35205L4.35254 2.21924Z",
    fill: "#20C3FF",
    stroke: "#20C3FF",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.7c57b70b13a3a2504930ebc743f8aa93.svg";
export { ForwardRef as ReactComponent };